runOnLoad "SegmentationCriterias", ["new", "create", "edit", "update"], ->

  SegmentationBuilder.setup()

runOnLoad "SegmentationCriterias", ["destroy"], ->

  new Concerns.Destroy

$(document).on "click", "#segment-preview-loader", ->

  spinner     = new Image
  spinner.src = require("@images/spinner-bar.gif")

  $loader = $(@)
  $target = $("#segment-preview-target")

  listId    = $loader.data("mailing-list-id")
  segmentId = $loader.data("segment-id")
  editId    = $loader.data("segment-editor-id")

  # Some browsers will put an outline on the link.. we don't want that.
  $loader.blur()

  url =
    if segmentId
      Routes.preview_results_mailing_list_segmentation_criteria_path(listId, segmentId)
    else if editId
      Routes.preview_results_mailing_list_segmentation_criterias_path(listId, sql: $(editId).val())

  if url
    $target.html(spinner)
    $target.load(url)

  return false
